import { render, staticRenderFns } from "./AssociateCards.vue?vue&type=template&id=82824532&"
import script from "./AssociateCards.vue?vue&type=script&lang=js&"
export * from "./AssociateCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports